'use strict'

module.exports = function assertOk (value, message) {
  if (!value) {
    throw new Error(message || 'Expected true, got ' + value)
  }
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/assert-ok/index.js
// module id = 71
// module chunks = 0